import { render, staticRenderFns } from "./ExportCustomers.vue?vue&type=template&id=0a3a2dfd&"
import script from "./ExportCustomers.vue?vue&type=script&lang=js&"
export * from "./ExportCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports